import { type PropsWithChildren } from "react";

export const Footer = ({ children }: Readonly<PropsWithChildren>) => (
  <div data-testid="circle-ai-shell-sidebar-footer" className="shrink-0">
    {children}
  </div>
);

Footer.displayName = "CircleAIAppShell.Layout.Sidebar.Footer";
